import type { AnnouncementsAnnounce, AnnouncementsClear } from './actions.types';

type Announce = (text: string) => AnnouncementsAnnounce;
// @deprecated For announcements in data layer, use an 'announceSuccess' callback, and use FUI9 useAnnounce or useAnnounceCallback in caller
export const announce: Announce = (text) => ({
  type: 'ANNOUNCEMENTS.ANNOUNCE',
  payload: text,
});

type Clear = () => AnnouncementsClear;
export const clear: Clear = () => ({ type: 'ANNOUNCEMENTS.CLEAR' });
